import api from 'services/api'

const Api = {
    getAllTenants: () => api.get('/api/tenants', {
        headers: { 'Content-Type': 'application/json' }
    }),
    
    getTenant: id => api.get(`/api/tenants/${id}`, {
        headers: { 'Content-Type': 'application/json' }
    }),
    
    createTenant: tenant => api.post('/api/tenants', tenant, {
        headers: { 'Content-Type': 'application/json' }
    }),
    
    updateTenant: (id, tenant) => api.put(`/api/tenants/${id}`, tenant, {
        headers: { 'Content-Type': 'application/json' }
    }),
    
    deleteTenant: id => api.delete(`/api/tenants/${id}`, {
        headers: { 'Content-Type': 'application/json' }
    })
}

export default Api